import { render, staticRenderFns } from "./BottomLogo.vue?vue&type=template&id=2d101dd4&scoped=true"
import script from "./BottomLogo.vue?vue&type=script&lang=ts"
export * from "./BottomLogo.vue?vue&type=script&lang=ts"
import style0 from "./BottomLogo.vue?vue&type=style&index=0&id=2d101dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d101dd4",
  null
  
)

export default component.exports